import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../../../shared/components/footer/footer.component';
import { InspectionModalComponent } from '../inspection-modal/inspection-modal.component';
import { OrderData } from '../../../../shared/models/order';
import { AztecCodeComponent } from '../aztec-code/aztec-code.component';
import { TranslateModule } from '@ngx-translate/core';
import { DanishTimePipe } from "../../../../services/utility/danish-time.pipe";

@Component({
    selector: 'app-inspection-footer',
    standalone: true,
    imports: [CommonModule, TranslateModule, FooterComponent, InspectionModalComponent, AztecCodeComponent, DanishTimePipe],
    templateUrl: './inspection-footer.component.html',
    styleUrls: ['./inspection-footer.component.css'],
})
export class InspectionFooterComponent {
    @Input() orderData: OrderData | null = null;
    @Input() isTicketValid: boolean = false;

    isInspectionModalOpen = false;

    openInspectionModal(): void {
        if (!this.orderData) return;
        this.isInspectionModalOpen = true;
    }

    closeInspectionModal(): void {
        this.isInspectionModalOpen = false;
    }

    onFooterClick(): void {
        this.openInspectionModal();
    }
}
